export enum Theme {
    CUSTOMER = 'theme--customer',
    DELIVERER = 'theme--deliverer',
}
